/**
 * WorkshopsCardHeader — the "Workshops here" card header on a venue's Workshops
 * tab: title + subheader, the `Upcoming | Past | All` toggle, and the
 * "+ New workshop" trigger.
 *
 * Its own file so the tab declares one component (`react/no-multi-comp`).
 */
import { Plus } from 'lucide-react';

import type { WorkshopDirection } from '../../../../api/workshops';
import { SegmentedControl, ShowCancelledToggle } from '../../primitives';

/** The `Upcoming | Past | All` toggle options (BON-197). */
const DIRECTION_OPTIONS: ReadonlyArray<{ value: WorkshopDirection; label: string }> = [
  { value: 'upcoming', label: 'Upcoming' },
  { value: 'past', label: 'Past' },
  { value: 'all', label: 'All' },
];

export function WorkshopsCardHeader({
  venueName,
  canCreate,
  direction,
  onDirectionChange,
  showCancelled,
  onToggleCancelled,
  onCreate,
}: {
  venueName: string;
  /** Whether to draw the create trigger at all. */
  canCreate: boolean;
  direction: WorkshopDirection;
  onDirectionChange: (next: WorkshopDirection) => void;
  showCancelled: boolean;
  onToggleCancelled: () => void;
  onCreate: () => void;
}) {
  return (
    <div
      className="nb-card-hd"
      style={{ marginBottom: 8, display: 'flex', alignItems: 'center', gap: 10 }}
    >
      <div>
        <h3>Workshops here</h3>
        <span className="nb-eyebrow">Workshops scheduled at {venueName}</span>
      </div>
      <div style={{ flex: 1 }} />
      <ShowCancelledToggle showing={showCancelled} onToggle={onToggleCancelled} />
      <SegmentedControl
        value={direction}
        onChange={onDirectionChange}
        options={DIRECTION_OPTIONS}
        ariaLabel="Filter workshops by date"
      />
      {canCreate && (
        <button
          type="button"
          className="nb-btn nb-btn-primary"
          onClick={onCreate}
          style={{ display: 'flex', alignItems: 'center', gap: 5 }}
        >
          <Plus size={13} /> New workshop
        </button>
      )}
    </div>
  );
}
